import {Stack, Typography} from '@mui/material';

export const SectionDescription = ({label}: {label: string}): JSX.Element => (
  <Stack>
    <Typography variant="description" color={'secondary'} pt={2} pb={1}>
      {label}
    </Typography>
  </Stack>
);
